<div class="jumbotron jumbotron-fluid">
  <div class="container">
    <div class="d-flex flex-wrap">
      <div>
        <h1 class="display-3">SKILLS TO CATCH THE FUTURE</h1>
        <p class="lead">
SKILLS TO CATCH THE FUTURE aims at equipping students and teachers with computational skills to keep up to the ever-changing technology.

The specific objectives include:</p>
      </div>
    </div>
    <ul>
	    <li> developing critical thinking using digital communication techniques</li>
	    <li> using computational thinking skills in teaching and learning</li>
	    <li> applying computational thinking skills in individual and group projects</li>
    <li>enhancing cooperation skills for all communities involved in the project</li>
    </ul>
<!-- <p>Join an international community of <a href="https://wiki.lyrasis.org/display/DSPACE/DSpace+Positioning"
        target="_blank">leading institutions using DSpace</a>.
    </p>
-->

  </div>
</div>
